import { Observable, Scope } from 'wdc-cube'

@Observable
export class TheMapMarkDetailsScope extends Scope {
    onClose = Scope.ASYNC_ACTION
}